import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { CommonService } from '../service/commons-service';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-interested-users',
  templateUrl: './interested-users.component.html',
  styleUrls: ['./interested-users.component.css'],
})
export class InterestedUsersComponent implements OnInit {
  @ViewChild('closeApproveModel1', { read: ElementRef })
  closeApproveModel1: ElementRef;
  showHideModel: boolean = true;
  loading: boolean = false;
  myGroup: any;
  status = '';
  appRjctbtn: number = 1;
  viewNominatedData: any[] = [];
  isNominated: number = 0;
  getUserId: number = 0;
  getTowerId: number = 0;
  isApproved: number = 0;
  whyApproved = '';
  index: number = 0;
  interesteNominee: any[] = [];
  users: any = {};
  show: boolean = false;
  buttonName: any = 'HideApp';
  buttonNameR: any = 'HideAppR';
  positionList: any = [];
  ibuList: any = [];
  ibu: any = '';
  functionList: any = [];
  function: any = '';
  selectedIbuId: any = null;
  towerList: any = [];
  alltowerList: any = [];
  selectedTowerId: any;
  tower: any = '';
  nextRole: any = '';
  dataForm: FormGroup;
  showOtherNextRole: boolean = false;
  initialFormValueSet: boolean = false;
  @Output() valueChange = new EventEmitter<any>();
  maxCharForWhyToMoveLength: any = 500;
  maxLeftCharacterWhyToMove: any = this.maxCharForWhyToMoveLength;
  fromApprove: any = '';
  selectedTower = new FormControl();
  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    if (JSON.parse(localStorage.user).userData.userRoll == 5) {
      this.router.navigate(['/selfRating']);
    }
    this.getAllResoucesForTower();

    this.getAllIBUInfo();
    //this.getTowerList()

    //this.initalizeUserForm();
    this.myGroup = new FormGroup({
      fromApprove: new FormControl('', Validators.required),
      formReject: new FormControl('', Validators.required),
    });
  }

  initImportUserForm() {
    this.dataForm = this.formBuilder.group({
      userFile: ['', Validators.required],
      ibu: [],
    });
  }

  toggle(num) {
    this.appRjctbtn = num;
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show) this.buttonName = 'ShowAppR';
    else this.buttonName = 'HideAppR';
  }
  private getAllResoucesForTower() {
    this.loading = true;
    var formDetails = {
      towerId: JSON.parse(localStorage.user).userData.towerId,
      userId: JSON.parse(localStorage.user).userData.userId,
    };
    this.commonService
      .getAllResoucesForTower(formDetails)
      .pipe(first())
      .subscribe(
        (data) => {
          this.interesteNominee = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getAllIBUInfo() {
    this.loading = true;
    this.commonService
      .getAllIBUInfo()
      .pipe(first())
      .subscribe(
        (data) => {
          this.ibuList = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getTowerList() {
    this.loading = true;
    this.commonService
      .getTowerList()
      .pipe(first())
      .subscribe(
        (data) => {
          this.towerList = data;
          this.alltowerList = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //fetch Nominee user data
  private onclickViewNomineeUserData(
    towerid: number,
    userid: number,
    index: number
  ) {
    this.initialFormValueSet = false;
    this.positionList = [];
    this.nextRole = '';
    this.getUserId = userid;
    this.getTowerId = towerid;
    this.index = index;
    this.viewNominatedData = this.interesteNominee[index];
    if (this.viewNominatedData) {
      this.tower = this.viewNominatedData['towerId'];
      this.nextRole = this.viewNominatedData['nextPosition'];
      this.fetchPositions(this.viewNominatedData['towerId']);
      this.setFieldsData();
      console.log(this.viewNominatedData['towerId']);
      debugger;

      //this.getFunctionListByIbuId(this.viewNominatedData['ibuId']);
      // let tower = this.towerList.find(
      //   (tower) => tower.towerId == this.viewNominatedData['towerId']
      // );
      // debugger
      // this.getTowersListByIbuId(
      //   this.viewNominatedData['ibuId'],
      //   this.viewNominatedData['towerId']
      // );

      //   this.ibu = parseInt(tower.ibuId);

      // if(this.positionList.length) {
      //     this.nextRole =this.viewNominatedData['nextPosition'];
      //     console.log('this.nextRole', this.nextRole);
      // }
      if (this.viewNominatedData['nextPosition'] == null) {
        this.nextRole = null;
        this.showOtherNextRole = true;
      }
      if (this.viewNominatedData['whyApprove'] == null) {
        this.fromApprove = '';
        this.maxLeftCharacterWhyToMove = 500;
      }
    }
  }
  //close dailog box
  private closeModels() {
    this.closeApproveModel1.nativeElement.click();
  }
  private onClickAprvNRjct() {
    let oldApprsta;
    let WhyApprRjc = '';
    var isAppRj;
    for (let i in this.interesteNominee) {
      if (this.interesteNominee[i].userId == this.getUserId) {
        isAppRj = this.interesteNominee[i].isApproved;
        WhyApprRjc = this.interesteNominee[i].whyApprove;
      }
      oldApprsta = isAppRj;
      WhyApprRjc = WhyApprRjc;
    }
    if (!this.nextRole) {
      localStorage.setItem(
        'errorMsg',
        'Please request to TR team for adding new Role !'
      );
      localStorage.setItem('isReload', 'false');
      this.commonService.showerror();
      return;
    }
    if (this.appRjctbtn === 2) {
      isAppRj = 0;
      this.status = this.myGroup.value.formReject;
    } else if (this.appRjctbtn === 1) {
      isAppRj = 1;
      this.status = this.myGroup.value.fromApprove;
    } else {
      isAppRj = 2;
      this.status = 'User is new, Request is pending for Nomination';
    }

    let ibuValue = '';
    const formIbu: any = document.querySelector('#form-ibu');
    if (formIbu) {
      ibuValue = formIbu.value;
    }

    let towerValue = '';
    const formTower: any = document.querySelector('#form-tower');
    if (formIbu) {
      towerValue = formTower.value;
    }

    let functionValue = '';
    const formFunction: any = document.querySelector('#form-function');
    if (formIbu) {
      functionValue = formFunction.value;
    }

    let nextRoleValue = '';
    const formNextRole: any = document.querySelector('#form-next-role');
    if (formIbu) {
      nextRoleValue = formNextRole.value;
    }

    var formDetails = {
      userId: this.getUserId,
      whyApprove: this.status,
      isApproved: isAppRj,
      ibuId: ibuValue,
      towerId: towerValue,
      functionId: functionValue,
      nextPosition: nextRoleValue,
      //nextPosition:
      // this.nextRole == null || this.nextRole == 'null' ? null : this.nextRole,
    };
    var formStatusDetails = {
      userId: this.getUserId,
      oldStatus: oldApprsta,
      newStatus: isAppRj,
      whyApprRjctOld: WhyApprRjc,
      whyApprRjctNew: this.status,
    };

    if (this.status) {
      if (isAppRj == 1) {
        oldApprsta = isAppRj;
        WhyApprRjc = this.status;
        this.commonService
          .approveDisapprove(formDetails)
          .pipe(first())
          .subscribe(
            (data) => {
              // this.myGroup.reset();
              this.insertUserHistory(isAppRj);
              localStorage.setItem(
                'errorMsg',
                'Request has been approved  successfully!!'
              );
              localStorage.setItem('isReload', 'true');
              this.commonService.showerror();
              this.closeModels();
              localStorage.removeItem('errorMsg');
              this.interesteNominee[this.index].isApproved = isAppRj;
              this.commonService
                .statusHistoryData(formStatusDetails)
                .pipe(first())
                .subscribe(
                  (data) => {
                    this.getAllResoucesForTower();
                    //location.reload();
                  },
                  (error) => {
                    localStorage.setItem('errorMsg', error.statusText);
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                  }
                );
              // setTimeout(()=> {
              //     window.location.reload();
              // }, 5000);
            },
            (error) => {
              localStorage.setItem('errorMsg', error.statusText);
              this.commonService.showerror();
              localStorage.removeItem('errorMsg');
            }
          );
      } else {
        this.commonService
          .approveDisapprove(formDetails)
          .pipe(first())
          .subscribe(
            (data) => {
              // this.myGroup.reset();
              this.insertUserHistory(isAppRj);
              localStorage.setItem(
                'errorMsg',
                'Request has been rejected successfully!!'
              );
              localStorage.setItem('isReload', 'true');
              this.commonService.showerror();
              this.closeModels();
              localStorage.removeItem('errorMsg');
              this.commonService
                .statusHistoryData(formStatusDetails)
                .pipe(first())
                .subscribe(
                  (data) => {
                    this.getAllResoucesForTower();
                  },
                  (error) => {
                    localStorage.setItem('errorMsg', error.statusText);
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                  }
                );
            },
            (error) => {
              localStorage.setItem('errorMsg', error.statusText);
              this.commonService.showerror();
              localStorage.removeItem('errorMsg');
            }
          );
      }
    } else {
      localStorage.setItem('errorMsg', 'Please fill the Required Field!');
      this.commonService.showerror();
      localStorage.removeItem('errorMsg');
    }
  }

  valueChanged() {
    // You can give any function name
    this.valueChange.emit(this.status);
  }

  insertUserHistory(isAppRj) {
    this.commonService
      .getUserDetail(this.getUserId)
      .pipe(first())
      .subscribe(
        (result) => {
          if (result) {
            //  if(result.isApproved != isAppRj) {
            var userProfileHistory = {
              empCode: result[0].empCode,
              userName: result[0].userName,
              typeResource: result[0].typesResource,
              joinDate: result[0].joinDate,
              leaveDate: result[0].leaveDate,
              team: result[0].team,
              SUPCode: result[0].SUPCode,
              SLS: result[0].SLS,
              SLSE: result[0].SLSE,
              SLSUPCode: result[0].SLSUPCode,
              // 'SLST': userData.SLST,
              TTA: result[0].TTA,
              currentPosition: result[0].currentPosition,
              nextPosition: Number(result[0].nextPosition),
              email: result[0].email,
              resourceManager: result[0].resourceManager,
              resourceManagerEmail: result[0].resourceManagerEmail,
              empStatus: parseInt(result[0].empStatus),
              batchNo: result[0].batchNo,
              journeyCompletionDate: result[0].journeyCompletionDate
                ? moment(result[0].journeyCompletionDate).format('YYYY-MM-DD')
                : ' ',
              isApproved: isAppRj,
              createdByEmail: JSON.parse(localStorage.getItem('user')).userData
                .emailAddress,
            };
            if (result) {
              if (result.isApproved != isAppRj) {
                this.commonService
                  .saveUserProfileHistory(userProfileHistory)
                  .pipe(first())
                  .subscribe(
                    (result) => {},
                    (error) => {}
                  );
              }
            }
          }
        },
        (error) => {}
      );
  }
  // /fetch user information data
  private fetchPositions(towerId, positionId = '') {
    this.commonService.getAllPositionInfo(towerId).subscribe(
      (data) => {
        this.positionList = data;
        const formTower: any = document.querySelector('#form-next-role');
        if (formTower) {
          setTimeout(() => {
            formTower.value = positionId;
          }, 200);
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  public setFieldsData() {
    this.commonService
      .allInfoPosition(this.viewNominatedData['nextPosition'])
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length) {
            const response = data[0];
            this.viewNominatedData['isNextTowerSame'] =
              response.towerId == this.viewNominatedData['towerId'];
            this.onChangeIBU(null, response);
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getTowersListByIbuId(ibuId, towerId, dataValue) {
    this.commonService.getTowersListByIbuId(ibuId, null).subscribe(
      (data) => {
        this.towerList = data;
        this.alltowerList = data;
        if (dataValue) {
          const formTower: any = document.querySelector('#form-tower');

          if (formTower) {
            setTimeout(() => {
              formTower.value = dataValue.towerId;
            }, 200);
          }

          this.fetchPositions(dataValue.towerId, dataValue.positionId);
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getFunctionListByIbuId(ibuId, dataValue) {
    this.functionList = [];
    this.commonService.getFunctionListByIbuId(ibuId).subscribe(
      (data) => {
        this.functionList = data;
        if (dataValue) {
          const formFunction: any = document.querySelector('#form-function');
          console.log({ dataValue, formFunction });

          if (formFunction) {
            setTimeout(() => {
              formFunction.value = dataValue.functionId;
            }, 200);
          }
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private intiateSetFormValues() {
    //this.setIbuValue(this.viewNominatedData['nextPositionIbuId'])
    //this.setFunctionValue(this.viewNominatedData['nextPositionIbuId'])
  }

  onSelectNextRole(event) {
    let nextRoleVal = event.target.value;
    this.showOtherNextRole = false;
    if (nextRoleVal == null || nextRoleVal == 'null') {
      this.showOtherNextRole = true;
    }
    this.nextRole = nextRoleVal;
  }

  private onChangeIBU(event, dataValue) {
    console.log({ dataValue });
    debugger;
    let ibu = dataValue ? dataValue.ibuId : event.target.value;

    if (dataValue) {
      const formIbu: any = document.querySelector('#form-ibu');

      if (formIbu) {
        formIbu.value = dataValue.ibuId;
      }
    }

    this.resetFunctionValue();
    this.resetTowerValue();
    if (ibu) {
      this.getFunctionListByIbuId(ibu, dataValue);
      this.getTowersListByIbuId(ibu, 0, dataValue);
    } else {
      this.resetFunctionList();
      this.resetTowerList();
    }
  }

  private onChangeFunction(event) {
    let functionId = event.target.value;
    this.resetTowerValue();
    if (functionId) {
      this.towerList = this.alltowerList.filter(
        (item) => item.functionId == functionId
      );
    } else {
      this.towerList = this.alltowerList;
    }
  }
  private onChangeTower(event) {
    this.fetchPositions(event.target.value);
  }

  private resetFunctionValue() {
    this.function = '';
  }

  private resetTowerValue() {
    this.tower = '';
  }

  private resetFunctionList() {
    this.functionList = [];
  }

  private resetTowerList() {
    this.towerList = [];
  }

  /**
   * Apply validation on string by count string length.
   */
  onTextChange() {
    if (this.fromApprove.length) {
      this.maxLeftCharacterWhyToMove =
        this.maxCharForWhyToMoveLength - this.fromApprove.length;
      if (this.fromApprove.length > this.maxCharForWhyToMoveLength) {
        this.fromApprove = this.fromApprove.slice(
          0,
          this.maxCharForWhyToMoveLength
        );
      }
    }
  }

  test(val) {
    console.log(val);
    return val;
  }
}
